// Call layer: one file per backend router, so this module owns the /leaderboard half of the URL
// and builds the HTTP client once for every package that hangs off it.
import { useDashBaseAPI }                          from "./api/clients/useBaseAPI.js";
import { postCosPricesForCategory, getIndsPrices }  from "./api/packages/leaderboard.js";

const PREFIX = "/leaderboard"

export const useLeaderboardAPI = () => {
  const leaderboardHttpClient = useDashBaseAPI(PREFIX);

  const getCosPricesForCategory = async (payload) => {
    const response = await postCosPricesForCategory(leaderboardHttpClient, payload);
    console.log("[SUCCESS] Response from cos prices endpoint: ", response)    
    return response;
  };

   const getIndicesPrices = async () => {
    const response = await getIndsPrices(leaderboardHttpClient);
    console.log("[SUCCESS] Response from indices prices endpoint: ", response)    
    return response;
  }; 

  return {
    getCosPricesForCategory,
    getIndicesPrices
  };
};
